import React from 'react';

export default function DesktopTabs({ tabs = [], activeId, onTabClick }) {
	return (
		<div className="flex space-x-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-800">
			{tabs.map(tab => (
				<button
					key={tab.id}
					onClick={() => onTabClick?.(tab.id)}
					className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium ${
						activeId === tab.id 
						? 'bg-black text-white shadow-sm' 
						: 'text-black dark:text-gray-300'
					}`}
				>
					<span>{tab.icon}</span>
					<span>{tab.label}</span>
					{tab.badge && (
						<span className="ml-1.5 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
							{tab.badge}
						</span>
					)}
				</button>
			))}
		</div>
	);
}
